import React from "react";
import { Col, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

//STYLES
import * as SlotStyles from "../styles/slot";

//IMAGES
import albumImage from "../../../../../public/environmentPods/photoGallery/Ablum icon.png";

function ImageSlot(props) {
    const navigate = useNavigate();

    return (
        <div style={SlotStyles.cardBody}>
            <div style={SlotStyles.cardPicture}>
                <Image src={`/content/gallery/${props.album}/${props.name}`} style={SlotStyles.albumImage} />
            </div>
            <div style={SlotStyles.cardText}>{props.name}</div>
        </div>
    );
}

export default ImageSlot;
